import { render, staticRenderFns } from "./warrant.vue?vue&type=template&id=2750faf0&scoped=true&"
import script from "./warrant.vue?vue&type=script&lang=js&"
export * from "./warrant.vue?vue&type=script&lang=js&"
import style0 from "./warrant.vue?vue&type=style&index=0&id=2750faf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750faf0",
  null
  
)

export default component.exports